// useOffline — hook udostępnia isOnline / queueCount / queueStats / isUploading.
// Reaguje na: window online/offline + eventy z UploadManager.
//
// FAZA F-7 (2026-06-12): + queueStats { total, pending, uploading, failed } —
// baner rozdziela „X czeka" (pending+uploading) od „Y nieudanych" (failed).
// queueCount (total) zostaje dla backward-compat (ForceUploadButton visibility).

import { useEffect, useState } from 'react';
import { uploadManager } from '../services/uploadManager.js';
import { getQueueStats } from '../services/offlineDB.js';

const EMPTY_STATS = { total: 0, pending: 0, uploading: 0, failed: 0 };

export function useOffline() {
  const [isOnline, setIsOnline] = useState(
    typeof navigator !== 'undefined' ? navigator.onLine : true
  );
  const [queueStats, setQueueStats] = useState(EMPTY_STATS);
  const [isUploading, setIsUploading] = useState(false);

  useEffect(() => {
    let alive = true;
    const refreshStats = () => {
      getQueueStats()
        .then((s) => { if (alive) setQueueStats(s); })
        .catch(() => {});
    };

    const onOnline = () => setIsOnline(true);
    const onOffline = () => setIsOnline(false);
    window.addEventListener('online', onOnline);
    window.addEventListener('offline', onOffline);

    // Initial
    refreshStats();

    const unsub = uploadManager.subscribe((event) => {
      switch (event.type) {
        case 'processing-started':
          setIsUploading(true);
          break;
        case 'processing-done':
          setIsUploading(false);
          refreshStats();
          break;
        case 'queue-changed':
        case 'photo-uploaded':
        case 'upload-failed':
          // Statusy mogły się zmienić (failed/pending) — przelicz pełne statystyki.
          refreshStats();
          break;
        default:
          break;
      }
    });

    return () => {
      alive = false;
      window.removeEventListener('online', onOnline);
      window.removeEventListener('offline', onOffline);
      unsub();
    };
  }, []);

  return { isOnline, queueCount: queueStats.total, queueStats, isUploading };
}
